const W = 1080;
const H = 1920;

export const STORY_STYLES = [
  { id: "classic", label: "Classico" },
  { id: "highlight", label: "Evidenziato" },
  { id: "minimal", label: "Minimal" },
];

const bitmapCache = new Map();
async function loadBitmap(url) {
  if (!bitmapCache.has(url)) {
    const p = fetch(url).then((r) => r.blob()).then((b) => createImageBitmap(b));
    p.catch(() => bitmapCache.delete(url));
    bitmapCache.set(url, p);
  }
  return bitmapCache.get(url);
}

function wrap(ctx, text, maxW) {
  const lines = [];
  text.split("\n").forEach((para) => {
    let cur = "";
    para.split(/\s+/).filter(Boolean).forEach((w) => {
      const t = cur ? `${cur} ${w}` : w;
      if (ctx.measureText(t).width > maxW && cur) { lines.push(cur); cur = w; } else cur = t;
    });
    if (cur) lines.push(cur);
  });
  return lines;
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export async function renderSlide({ imageUrl, text, style = "classic", color = "#10B981" }) {
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");
  if (imageUrl) {
    const bmp = await loadBitmap(imageUrl);
    const s = Math.max(W / bmp.width, H / bmp.height);
    ctx.drawImage(bmp, (W - bmp.width * s) / 2, (H - bmp.height * s) / 2, bmp.width * s, bmp.height * s);
  } else {
    const g = ctx.createLinearGradient(0, 0, W * 0.4, H);
    g.addColorStop(0, color); g.addColorStop(0.85, "#0b0c10");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  }
  const clean = (text || "").replace(/\*\*/g, "").trim();
  if (!clean) return canvas;

  const minimal = style === "minimal";
  let size = 76;
  let lines;
  const maxW = W - 220;
  do {
    ctx.font = `${minimal ? 600 : 700} ${size}px "Plus Jakarta Sans", "Segoe UI", Arial, sans-serif`;
    lines = wrap(ctx, clean, maxW);
    size -= 4;
  } while (lines.length * size * 1.3 > H * 0.5 && size > 30);
  size += 4;
  const lh = size * 1.3;
  const blockH = lines.length * lh;
  const cy = minimal ? H * 0.68 : H / 2;
  const top = cy - blockH / 2;

  if (!minimal) {
    const padX = 70; const padY = 60;
    const bw = Math.min(W - 80, Math.max(...lines.map((l) => ctx.measureText(l).width)) + padX * 2);
    ctx.fillStyle = style === "highlight" ? hexA(color, 0.88) : "rgba(0,0,0,0.55)";
    roundRect(ctx, (W - bw) / 2, top - padY, bw, blockH + padY * 2, 36);
    ctx.fill();
  } else {
    const g = ctx.createLinearGradient(0, H * 0.4, 0, H);
    g.addColorStop(0, "rgba(0,0,0,0)"); g.addColorStop(1, "rgba(0,0,0,0.75)");
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.4, W, H * 0.6);
  }
  ctx.fillStyle = "#ffffff";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  if (minimal) { ctx.shadowColor = "rgba(0,0,0,0.6)"; ctx.shadowBlur = 18; }
  lines.forEach((l, k) => ctx.fillText(l, W / 2, top + lh * k + lh / 2));
  return canvas;
}

function hexA(hex, a) {
  const n = parseInt(hex.replace("#", ""), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}

export const canvasToBlob = (c) => new Promise((res) => c.toBlob(res, "image/png"));

export function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
